export default __webpack_public_path__ + "static/media/JUAN PABLO LLAMBI.6e267ebe.jpg";